import React from 'react';
import { CheckCircle, Clock, Edit2, Coins, FileText } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../../components/ui/card';
import { Badge } from '../../../components/ui/badge';
import { TabsContent } from '../../../components/ui/tabs';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../components/ui/select';

const ApprovedTab = ({ allContent, contentTypeFilter, setContentTypeFilter, handleSetPrice, getItemIcon, getItemTitle }) => (
    <TabsContent value="approved">
        <Card>
            <CardHeader>
                <div className="flex items-center justify-between">
                    <div>
                        <CardTitle className="flex items-center">
                            <CheckCircle className="h-5 w-5 mr-2 text-green-600" />
                            Approved Content
                        </CardTitle>
                        <CardDescription>All approved jobs, tuitions, tutors, and organizations</CardDescription>
                    </div>
                    <div className="flex items-center space-x-3">
                        <Select value={contentTypeFilter} onValueChange={setContentTypeFilter}>
                            <SelectTrigger className="w-40">
                                <SelectValue placeholder="Type" />
                            </SelectTrigger>
                            <SelectContent>
                                <SelectItem value="all">All Types</SelectItem>
                                <SelectItem value="job">Jobs</SelectItem>
                                <SelectItem value="tuition">Tuitions</SelectItem>
                                <SelectItem value="tutor">Tutors</SelectItem>
                                <SelectItem value="organization">Organizations</SelectItem>
                            </SelectContent>
                        </Select>
                    </div>
                </div>
            </CardHeader>
            <CardContent>
                {(() => {
                    let items = [];
                    if (contentTypeFilter === 'all' || contentTypeFilter === 'job') {
                        items = [...items, ...allContent.jobs];
                    }
                    if (contentTypeFilter === 'all' || contentTypeFilter === 'tuition') {
                        items = [...items, ...allContent.tuitions];
                    }
                    if (contentTypeFilter === 'all' || contentTypeFilter === 'tutor') {
                        items = [...items, ...allContent.tutors];
                    }
                    if (contentTypeFilter === 'all' || contentTypeFilter === 'organization') {
                        items = [...items, ...allContent.organizations];
                    }
                    const approvedItems = items.filter(item => item && item.id && item.review_status === 'approved');
                    return approvedItems.length === 0 ? (
                        <div className="text-center py-16 text-gray-500">
                            <FileText className="h-20 w-20 mx-auto mb-4 text-gray-300" />
                            <p className="text-xl font-medium">No approved content yet</p>
                            <p className="text-gray-400">Approved items will appear here</p>
                        </div>
                    ) : (
                        <div className="space-y-4">
                            <div className="mb-4 text-sm text-gray-500">
                                Showing {approvedItems.length} approved items
                            </div>
                            {approvedItems.map((item) => (
                                <div
                                    key={`${item.type}-${item.id}`}
                                    className="border rounded-lg p-4 hover:shadow-md transition-all border-l-4 border-l-green-400"
                                >
                                    <div className="flex items-start justify-between">
                                        <div className="flex items-start space-x-4">
                                            <div className={`p-2 rounded-lg ${item.type === 'job' ? 'bg-blue-100' :
                                                item.type === 'tuition' ? 'bg-green-100' :
                                                    item.type === 'tutor' ? 'bg-purple-100' : 'bg-orange-100'
                                                }`}>
                                                {getItemIcon(item.type)}
                                            </div>
                                            <div>
                                                <div className="flex items-center space-x-2 mb-1">
                                                    <h3 className="font-semibold">{getItemTitle(item)}</h3>
                                                    <Badge variant="secondary" className="capitalize">{item.type}</Badge>
                                                    <Badge className="bg-green-100 text-green-700">Approved</Badge>
                                                </div>
                                                <div className="flex items-center space-x-4 text-sm text-gray-500">
                                                    <span className="flex items-center">
                                                        <Coins className="h-4 w-4 mr-1 text-yellow-500" />
                                                        {item.unlock_price || 0} coins unlock price
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex space-x-2">
                                            <Button size="sm" variant="outline" onClick={() => handleSetPrice(item)}>
                                                <Edit2 className="h-4 w-4 mr-2" />
                                                Edit Price
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    );
                })()}
            </CardContent>
        </Card>
    </TabsContent>
);

export default ApprovedTab;
